import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { BulkDeletePagesActionProps } from './BulkDeletePagesAction.ts';
export type { BulkDeletePagesActionProps } from '../src/Delete/BulkDeletePagesAction.tsx';
export const BulkDeletePagesActionLoader: LoadableType<BulkDeletePagesActionProps> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BulkDeletePagesActionLoader" */ '../src/Delete/BulkDeletePagesAction.tsx'
			)
		).BulkDeletePagesAction,
});
